import { useCallback } from 'react';
import { rage } from '~/rage';
import { Gender } from '~/shared';
import { setGender, useLayoutDispatch, useLayoutSelector } from '../redux';
import { useResetOverlays } from './useResetOverlays';

const useChangeGender = () => {
	const dispatch = useLayoutDispatch();
	const charCreationModalVisible = useLayoutSelector(
		(state) => state.characterCreation.charCreationModalVisible,
	);
	const parentsValue = useLayoutSelector(
		(state) => state.characterCreation.parentsValue,
	);
	const faceMorphValues = useLayoutSelector(
		(state) => state.characterCreation.faceMorphValues,
	);

	const handleResetOverlays = useResetOverlays();

	const handleChangeGender = useCallback(
		async (targetGender: Gender) => {
			if (charCreationModalVisible) {
				return;
			}

			dispatch(setGender(targetGender));
			await rage.characterCreation.setGenderValue(targetGender);
			await rage.characterCreation.setParentsValue(parentsValue);
			rage.characterCreation.setFaceMorphValues(faceMorphValues);
			await handleResetOverlays(targetGender);
		},
		[charCreationModalVisible, parentsValue, faceMorphValues],
	);

	return handleChangeGender;
};

export { useChangeGender };
